<template>
    <div class="meeting">
        <advertising-figure :bannerSrc="bannerSrc"/>
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Meeting Information</span>
            </public-title>

            <div class="meet-list">
                <el-row :gutter="20">
                    <el-col
                        :span="6"
                        v-for="(item, index) in meetList"
                        :key="item + index"
                    >
                        <el-card
                            shadow="always"
                            @click.native="handleMeetingCard(item.path)"
                        >
                            <div class="image">
                                <img :src="item.imgUrl" />
                            </div>
                            <div class="wrap">
                                <div class="meet-info">
                                    <!-- <div class="box"> -->
                                        <h2 class="tit">{{ item.title }}</h2>
                                        <!-- <p class="tips">{{ item.subTitle }}</p>
                                        <p class="tips">{{ item.text }}</p> -->
                                    <!-- </div> -->
                                    <!-- <div class="box">
                                        <span class="time"
                                            >发布日期: {{ item.date }}</span
                                        >
                                        <span class="day">{{ item.day }}</span>
                                    </div> -->
                                </div>
                                <!-- <el-divider></el-divider> -->
                                <div class="meet-info">
                                    <!-- <span class="block"></span> -->
                                    <p class="more">
                                        了解更多
                                        <i class="el-icon-d-arrow-right"></i>
                                    </p>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

                <!-- <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="100"
                /> -->
            </div>
        </div>
    </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";
// import CurrentConferMixin from "@/mixin/CurrentConference"

export default {
    name: "MeetingPage",
    components: {
        publicTitle,
        AdvertisingFigure,
        InnerPageNav,
    },
    data() {
        return {
            bannerSrc:require("@assets/img/meeting-banner.png"),
            title: "会议信息",
        };
    },
    // mixins: [CurrentConferMixin],
    computed: {
        meetList() {
            return [
                {
                    imgUrl: require("@assets/img/meeting-overview.jpg"),
                    title: "会议概况",
                    subTitle: "会议情况了解",
                    text: "敬请参阅",
                    date: "2022-1",
                    day: "15",
                    path:"MeetingDetails"
                },
                {
                    // imgUrl: "https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png",
                    imgUrl: require("@assets/img/meeting-inform.jpg"),
                    title: "会议通知",
                    subTitle: "会议情况了解",
                    text: "敬请参阅",
                    date: "2022-1",
                    day: "15",
                    path:"informListPage"
                },
                {
                    imgUrl: require("@assets/img/meeting-notice.jpg"),
                    title: "参会须知",
                    subTitle: "会议情况了解",
                    text: "敬请参阅",
                    date: "2022-1",
                    day: "15",
                    path:"noticeListPage"
                },
                {
                    imgUrl: require("@assets/img/meeting-meetingplace.jpg"),
                    title: "会场信息",
                    subTitle: "会议情况了解",
                    text: "敬请参阅",
                    date: "2022-1",
                    day: "15",
                    path:"siteListPage"
                },
                {
                    imgUrl: require("@assets/img/meeting-hotel.jpg"),
                    title: "酒店信息",
                    subTitle: "会议情况了解",
                    text: "敬请参阅",
                    date: "2022-1",
                    day: "15",
                    path:"hotelListPage"
                },
                {
                    imgUrl: require("@assets/img/meeting-agenda.jpg"),
                    title: "会议日程",
                    subTitle: "会议情况了解",
                    text: "敬请参阅",
                    date: "2022-1",
                    day: "15",
                    path:"agendaListPage"
                },
                {
                    imgUrl: require("@assets/img/meeting-arrangement.jpg"),
                    title: "会务安排",
                    subTitle: "会议情况了解",
                    text: "敬请参阅",
                    date: "2022-1",
                    day: "15",
                    path:"affairsListPage"
                },
                // {
                //     imgUrl: require("@assets/img/home-about.jpg"),
                //     title: "魅力北京",
                //     subTitle: "会议情况了解",
                //     text: "敬请参阅",
                //     date: "2022-1",
                //     day: "15",
                //     path:""
                // },
            ];
        },
    },

    methods: {
        handleMeetingCard(path) {
            
                this.$router.push({
                    name: path,
                }); 
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

.inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
}

.inner-page-content {
    margin: 60px 0;
}

.meet-list {
    position: relative;
    width: 1200px;
    margin: 60px auto 0;
    padding: 0 15px;

    .el-row {
        margin-top: -40px;
    }

    .el-col {
        margin-top: 40px;

        .el-card {
            border: none;

            &:hover {
                .wrap {
                    background: $defaultColor;

                    .block {
                        background: #fff;
                    }

                    .tit,
                    .tips,
                    .time,
                    .day,
                    .more {
                        color: #fff;
                    }
                }

                .image {
                    img {
                        transform: scale(1.2);
                    }
                }
            }

            ::v-deep .el-card__body {
                padding: 0;
            }

            .image {
                width: 100%;
                height: 170px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    transition: transform 0.3s ease-out;
                }
            }

            .wrap {
                padding: 14px;
                margin-top: -4px;
            }

            .meet-info {
                @include flex-between;

                .block {
                    width: 15px;
                    height: 3px;
                    background: $defaultColor;
                    transition: all 0.3s ease-out;
                }

                .tit {
                    font-size: 16px;
                    color: #424242;
                    margin-bottom: 10px;
                }

                .tips {
                    font-size: 12px;
                    line-height: 20px;
                    color: #999;
                }

                .box {
                    flex: 1;
                    position: relative;
                    min-height: 70px;
                }

                .time {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    color: #999;
                    font-size: 14px;
                }

                .day {
                    position: absolute;
                    top: 0;
                    right: 0;
                    font-size: 32px;
                }

                .more {
                    flex: 1;
                    text-align: right;
                    font-size: 14px;
                    color: $defaultColor;
                    cursor: pointer;
                }
            }
        }
    }

    .el-pagination {
        display: flex;
        justify-content: center;
        margin-top: 60px;
    }
}
</style>